import '../scss/auth.scss';
import Logo from '../assets/COOPER_NEW.png';
import LogoRMS from '../assets/rms_logo.png';
import LogoRMSWhite from '../assets/rms_white.png';
import appConfig from '../utils/appConfig';
import { getThemeMode, ThemeMode } from '../utils/theme';
import { useState } from 'react';
function AccessDeniedPage() {

    const windowUrl = (window.location.href);
    const [themeMode, setThemeModeState] = useState<ThemeMode>(() => {
        return getThemeMode();
      });
    return (
    <div className="access-denied-wrapper">
        <div className='main-section'>
            <img src={appConfig.projectName === 'AskCooper AI' ? Logo : themeMode === 'dark' ? LogoRMSWhite : LogoRMS} className='logo'/>
            {(windowUrl.includes("localhost")||windowUrl.includes("-dev")) && 
            <h2 className='env'>DEVELOPMENT</h2>
            }
            {(windowUrl.includes("-test")) && 
            <h2 className='env'>TESTING</h2>
            }
            <h1 className={'access-denied-header'}>Access Denied</h1>
            <p className={'notice'}>You don't have permission to view this page.<br/>If you believe this is a mistake, please contact your administrator for assistance.</p>
        </div>
    </div>
  );
}   

export default AccessDeniedPage;
